<template>
    <transition name="el-zoom-in-top" mode="out-in">
        <router-view></router-view>
    </transition>
</template>

<script>
    export default {
        name: "seting"
    }
</script>

<style scoped>

</style>
